import styles from "./styles.module.scss";

export function Separator({ position = "top", backgroundColor, angleColor, height, angle, margin }) {
	return (
		<div
			className={`${styles.separator} ${styles[position]}`}
			style={{
				"--color-background": backgroundColor ? `rgba(${backgroundColor.rgb.r},${backgroundColor.rgb.g},${backgroundColor.rgb.b},${backgroundColor.rgb.a})` : "transparent",
				"--wrapper-height": height,
				"--color-angle": angleColor ? `rgba(${angleColor.rgb.r},${angleColor.rgb.g},${angleColor.rgb.b},${angleColor.rgb.a})` : "transparent",
				"--angle-height": `${angle}px`,
				"--margin": margin
			}}
		>
			<div className={styles.background}></div>
			<div className={styles.angle}></div>
		</div>
	);
}